import Flickity from 'flickity';

export default function updateVariantImage(id) {
  const slider = document.querySelector('.js-product-gallery');
  if (!slider) return;

  const gallery = Flickity.data(slider);
  if (!gallery) return;

  // Match complete variant IDs; a partial selector can select another variant.
  const index = gallery.cells.findIndex((cell) =>
    (cell.element.getAttribute('data-variants') || '').split(',').includes(String(id))
  );
  if (index >= 0) gallery.select(index);
}
